import _merge from 'lodash/merge';

import { getInitialState } from './initialState';

const initialState = getInitialState(false);

const accountOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'account-options/saveData':
      return _merge({}, action.payload.defaultOptions, action.payload.accountOptions);

    default:
      return state;
  }
};

export default accountOptionsReducer;
